'use client';
import { createContext } from '@chakra-ui/utils/context';

const [RadioGroupContextProvider, useRadioGroupContext] = createContext({
  name: "RadioGroupContext",
  strict: false
});
const [RadioItemContextProvider, useRadioItemContext] = createContext({
  name: "RadioItemContext",
  strict: false
});
const [RadioThemingContextProvider, useRadioThemingContext] = createContext({
  name: "RadioGroupContext",
  strict: false
});
const [RadioItemStylesProvider, useRadioItemStyles] = createContext({
  name: "RadioItemStylesContext",
  hookName: "useRadioItemStyles",
  providerName: "<RadioGroup.Item />"
});

export { RadioGroupContextProvider, RadioItemContextProvider, RadioItemStylesProvider, RadioThemingContextProvider, useRadioGroupContext, useRadioItemContext, useRadioItemStyles, useRadioThemingContext };
